import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allStoragePlanAsync } from '../AkademySlice';
import { Box, Button, Modal, Select, MenuItem } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import CreatePlan from './CreatePlan';

function AkademyStoragePlan() {
  const dispatch = useDispatch();
  const [storageCurrency, setStorageCurrency] = useState('INR');

  const { allPlans } = useSelector(({ akademyReducer }) => {
    return {
      allPlans: akademyReducer.allPlans,
    };
  });
  const dataCall = () => dispatch(allStoragePlanAsync(storageCurrency));

  useEffect(() => {
    dataCall();
  }, []);

  useEffect(() => {
    dataCall();
  }, [storageCurrency]);

  const [showFormModal, setFormModal] = useState(false);

  const storageColumns = [
    // { Header: 'Plan Id', accessor: 'planId' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Description', accessor: 'description' },
    { Header: 'Currency', accessor: 'currency' },
    { Header: 'Price', accessor: 'price' },
    { Header: 'Size (in GB)', accessor: 'sizeInGb' },
    { Header: 'Duration (In Months)', accessor: 'durationInMonths' },
  ];

  return (
    <Box>
      <Box
        my={2}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '2rem',
        }}>
        <Button
          onClick={() => setFormModal(true)}
          variant={'contained'}
          color="primary">
          Create Storage Plan
        </Button>
        <Select
          value={storageCurrency}
          onChange={(e) => setStorageCurrency(e.target.value)}
          variant="outlined">
          <MenuItem value={'INR'}>INR</MenuItem>
          <MenuItem value={'USD'}>USD</MenuItem>
        </Select>
      </Box>
      <Box my={2}>
        <BuzzTable
          columns={storageColumns}
          data={allPlans}
          isHandlePagination={true}
        />
      </Box>
      <Modal open={showFormModal} onClose={() => setFormModal(false)}>
        <CreatePlan
          apiCall={() => dataCall()}
          onClose={() => setFormModal(false)}
        />
      </Modal>
    </Box>
  );
}

export default AkademyStoragePlan;
